module.exports = __webpack_public_path__ + "static/media/audits.520fd704.svg";